// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-KdOvWN","ui-button-spin":"ui-button-spin-RDirhR","uiButtonSpin":"ui-button-spin-RDirhR"};